/* Model */
class OrderClassModel extends App.Models.BaseModel {
  modelUrl = 'OrderClass';
}
App.Models.OrderClass = OrderClassModel;

/* Collection */
class OrderClassCollection extends App.Collections.BaseCollection {
  url = 'OrderClass';
  model = App.Models.OrderClass;
}
App.Collections.OrderClasss = OrderClassCollection;

/* Router */
class OrderClassRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'OrderClass';
      const model = App.Models.OrderClass;
      const collectionClass = App.Collections.OrderClasss;

      super(entityName, model, collectionClass);
  }
}

App.Routers.OrderClass = OrderClassRouter;